"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definePersonalizationService = void 0;
const v1_1 = require("./v1");
const v2_1 = require("./v2");
/**
 * Returns a factory for {@link IPersonalizationServiceV1}s.
 */
const definePersonalizationService = () => {
    return {
        id: "audi-personalization-service",
        create: () => ({
            "1.0.0": () => ({
                featureService: new v1_1.PersonalizationServiceV1(),
            }),
            "2.0.0": () => ({
                featureService: new v2_1.PersonalizationServiceV2(),
            }),
        })
    };
};
exports.definePersonalizationService = definePersonalizationService;
//# sourceMappingURL=index.js.map